import { isObjectLike } from 'lodash';

const toQueryParams = (obj) => { 
    
    if(!obj) return '';

    return Object.entries(obj)
            .map( ([key, value]) => 
                encodeURIComponent(key) + '=' + encodeURIComponent(isObjectLike(value) ? JSON.stringify(value) : value)
            )
            .join('&');  
};

export default toQueryParams;